import React from 'react';
import styled from 'styled-components';
import TransChart from './HomeChart/transChart';
import OrderTransChart from './HomeChart/orderTransChart';

const ChartWrapper = styled.div`
  padding: 16px;
  & > * {
    margin-bottom: 16px;
  }
`;

class Home extends React.Component {
  render() {
    return (
      <ChartWrapper>
        <div className="input-search">
          <div className="fll">
            <h3>Bảng điều khiển</h3>
          </div>
        </div>
        <TransChart
          name="Thống kê nạp rút trong sàn"
          fetchFunction={this.props.fetchTrans}
          trans={this.props.trans}
          coins={this.props.coins}
        />

        <TransChart
          name="Thống kê nạp rút ngoài sàn"
          fetchFunction={this.props.fetchExtTrans}
          trans={this.props.extTrans}
          coins={this.props.coins}
        />
        <OrderTransChart
          fetchFunction={this.props.fetchOrderTrans}
          markets={this.props.markets}
          orderTrans={this.props.orderTrans}
        />
      </ChartWrapper>
    );
  }
}

export default Home;
